'use client'

import { useEffect, useRef } from 'react'
import {
  trackVisaPageViewed,
  trackArticleViewed,
  trackResourceCenterViewed,
} from '../lib/analytics'

/** Fires visa_page_viewed once on mount */
export function TrackVisaPageView({ visaType }: { visaType: string }) {
  const tracked = useRef(false)
  useEffect(() => {
    if (tracked.current) return
    tracked.current = true
    trackVisaPageViewed(visaType)
  }, [visaType])
  return null
}

/** Fires article_viewed once on mount */
export function TrackArticleView({
  articleTitle,
  articleType,
  author,
}: {
  articleTitle: string
  articleType: 'article' | 'visa_guide'
  author?: string
}) {
  const tracked = useRef(false)
  useEffect(() => {
    if (tracked.current) return
    tracked.current = true
    trackArticleViewed({ article_title: articleTitle, article_type: articleType, author })
  }, [articleTitle, articleType, author])
  return null
}

/** Fires resource_center_viewed once on mount */
export function TrackResourceCenterView() {
  const tracked = useRef(false)
  useEffect(() => {
    if (tracked.current) return
    tracked.current = true
    trackResourceCenterViewed()
  }, [])
  return null
}
